import { Grid } from '@mui/joy'
import { useGate, useStore, useStoreMap } from 'effector-react'
import { Form, massMailingModel } from '~/entities/MassMailing'
import { usePermissions } from '~/entities/viewer'
import { $massMailing, $canEditMassMailing, formSubmitted } from './model'

type EditMassMailingProps = {
  massMailingId: string
}

export const EditMassMailing = ({ massMailingId }: EditMassMailingProps) => {
  const { canMassMailingUpdate } = usePermissions()
  useGate(massMailingModel.Gate, { massMailingId })

  const isLoading = useStore(massMailingModel.requestFx.pending)
  const isSaving = useStore(massMailingModel.saveMassMailingFx.pending)
  const canEditByStatus = useStore($canEditMassMailing)

  const defaultValues = useStoreMap($massMailing, (massMailing) => {
    return {
      ...massMailing?.getAttributes(),
      userStatuses: massMailing?.getUserStatusesOptions(),
      regionsIds: massMailing
        ?.getRegions()
        ?.map((region) => region.getOption()),
    }
  })

  const canEdit = canMassMailingUpdate && canEditByStatus

  return (
    <Grid xs={12}>
      <Form
        isLoading={isLoading}
        isSubmitting={isSaving}
        defaultValues={defaultValues}
        canEdit={canEdit}
        onSuccess={formSubmitted}
      />
    </Grid>
  )
}
